import { castArray, pick } from 'lodash';
import UIkit from 'uikit';

export default (mixinOptions = {}) => {
  const events = castArray(mixinOptions.events || []);
  const delegates = castArray(mixinOptions.delegate || []);
  const methods = {};
  delegates.forEach((name) => {
    methods[name] = function delegate() {
      return this.originalComponent[name]();
    };
  });

  return {
    data() {
      return { originalComponent: null };
    },
    mounted() {
      const options = pick(this, mixinOptions.props);
      const constructor = UIkit[mixinOptions.name];
      const component = constructor(this.originalComponentElement, options);

      // Forward all known events
      events.forEach((event) => {
        component.$el.on(event, () => { this.$emit(event); });
      });

      this.originalComponent = component;
    },
    updated() {
      this.originalComponent.$update();
    },
    destroyed() {
      this.originalComponent.$destroy();
      this.originalComponent = null;
    },
    computed: {
      originalComponentElement() {
        if (!mixinOptions.ref) return this.$el;
        return this.$refs[mixinOptions.ref];
      },
    },
    methods,
  };
};



// WEBPACK FOOTER //
// ./mixins/UIkitComponentWrapper.js